import React, { useContext, useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';
import './../styles/ProfileMenu.css';

// Displays Account Related Pages
const ProfileMenu = () => {
  const { logout, isAdmin } = useContext(AuthContext);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  // Input: User clicks on logout button
  // Output: Logs out user by removing thier token, user info, and search pagination from local storage.
  // Error: Need to assess Network level requirements for ending a logged in session
  const handleLogout = (e) => {
    e.preventDefault();
    logout();
    navigate('/');
  };
  
  // Input: Click on admin dashboard
  // Output: Switches between normal and admin views
  const handleViewToggle = (e) => {
    e.preventDefault();
    setDropdownOpen(false); // Close the dropdown after clicking
    if (location.pathname === '/admin/dashboard') {
      navigate('/'); // Redirect to homepage
    } else {
      navigate('/admin/dashboard'); // Redirect to admin dashboard
    }
  };

  return (
    <div className="profile-menu" onClick={toggleDropdown}>
      <img src="/user.png" alt="Profile" className="profile-icon" />
      {dropdownOpen && (
        <div className="dropdown-content">
          <Link to="/profile">Profile</Link>
          {isAdmin && (
            <Link to="#" onClick={handleViewToggle} className="view-toggle-link">
              {location.pathname === '/admin/dashboard' ? 'HomePage View' : 'AdminPage View'}
            </Link>
          )}
          <Link to="/favorites">Favorites</Link>
          <Link to="/saved-searches">Saved Searches</Link>
          <Link to="/" onClick={handleLogout}>Logout</Link>
        </div>
      )}
    </div>
  );
};

export default ProfileMenu;
